import React, { createContext, useContext, useState, useCallback } from 'react';
import api from '../api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('turismo_user')); } catch { return null; }
  });
  const [token, setToken] = useState(() => localStorage.getItem('turismo_token'));

  const login = useCallback(async (email, password) => {
    const res = await api.post('/auth/login', { email, password });
    const { access_token, user: u } = res.data;
    localStorage.setItem('turismo_token', access_token);
    localStorage.setItem('turismo_user', JSON.stringify(u));
    setToken(access_token);
    setUser(u);
    return u;
  }, []);

  const logout = useCallback((slug) => {
    localStorage.removeItem('turismo_token');
    localStorage.removeItem('turismo_user');
    setToken(null);
    setUser(null);
    if (slug) window.location.href = `/${slug}/login`;
  }, []);

  const isAuthenticated = Boolean(token && user);

  const hasRole = useCallback((...roles) => {
    return roles.includes(user?.role);
  }, [user]);

  return (
    <AuthContext.Provider value={{ user, token, isAuthenticated, login, logout, hasRole }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
